module.exports = __webpack_public_path__ + "static/media/audio.d24806ec.svg";